function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useMemo } from 'react';
import { components } from 'react-select';
import { getAutoCompleteProps } from '../../../../utils/form-field-utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var SelectInput = props => {
  var autoCompleteProps = useMemo(() => getAutoCompleteProps(), []);
  return /*#__PURE__*/_jsx(components.Input, _objectSpread(_objectSpread({}, props), {}, {
    "data-component": "_Select",
    id: props.selectProps.inputId,
    "data-testid": props.selectProps['data-testid'],
    "aria-invalid": props.selectProps.isInvalid,
    readOnly: props.selectProps.isReadOnly,
    onKeyDown: event => {
      if (event.key === 'Enter') event.preventDefault();
    }
  }, autoCompleteProps));
};
//# sourceMappingURL=SelectInput.js.map